<template>
  <div>
    <h1>Pamarin Developers</h1>
    <router-link to="/th/docs">Document</router-link>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = "Pamarin Developers";
  },
};
</script>

<style scoped>
.app-haeder {
  height: 56px;
  background-color: #2b2b2b;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style> 